import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import i18n from '@/utils/i18n'
import VueCookie from 'vue-cookie'
import '@/assets/scss/Style.scss'
import InfiniteLoading from "vue-infinite-loading";
 
Vue.config.productionTip = false
window.__native_money91 = {}
window._JWT = {}
Vue.use(VueCookie);
Vue.use(InfiniteLoading);

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
